import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import {
    Switch,
    Route,
    useRouteMatch,
    NavLink,
    useLocation,
} from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import SubMenu from '../../components/SubMenu';
import TransferAgents from '../../pages/admin/TransferAgents/TransferAgents';

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const AdminTransferAgentRoutes = (props) => {
    let { path } = useRouteMatch();
    const location = useLocation();

    const getActiveTab = () => {
        switch (location.pathname) {
            case '/admin/transfer-agents':
                return 0;
            default:
                return 0;
        }
    };

    const [value, setValue] = useState(getActiveTab());
    return (
        <div>
            <SubMenu value={value} onChange={(e, v) => setValue(v)}>
                <Tab
                    label="Transfer Agents"
                    {...a11yProps(0)}
                    to={`${path}`}
                    component={NavLink}
                />
            </SubMenu>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}`} component={TransferAgents} />
                </Switch>
            </TabPanel>
        </div>
    );
};

export default AdminTransferAgentRoutes;
